import { getRegistrations } from './internalState';

export function setMissionToSidebarMoveHandler(handler) {
  getRegistrations().moveHandler = handler;
}

/** Register a ref whose `.current` holds { localSprint, isMultiCampaignMode } — updated every render. */
export function registerMissionDragContextRef(ref) {
  getRegistrations().dragContextRef = ref;
}

export function clearMissionDragContextRef(ref) {
  const registrations = getRegistrations();
  if (registrations.dragContextRef === ref) {
    registrations.dragContextRef = null;
  }
}

export function getMissionDragContext() {
  return getRegistrations().dragContextRef?.current ?? null;
}
